import { render } from "./TXModal.vue?vue&type=template&id=24904716&scoped=true"
import script from "./TXModal.vue?vue&type=script&lang=js"
export * from "./TXModal.vue?vue&type=script&lang=js"

import "./TXModal.vue?vue&type=style&index=0&id=24904716&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24904716"]])

export default __exports__